// src/components/About.js
import React from "react";

const About = ({ id }) => (
  <section id={id} style={styles.section}>
    <h2 style={styles.heading}>Dra. Talía Chávez Palencia</h2>
    <h3 style={styles.subheading}>
      Consultora en Diversidad, equidad e inclusión
    </h3>
    <p style={styles.text}>
      Doctora en educación con la investigación referente a los significados de
      docentes y directivos sobre el fenómeno de inclusión y exclusión
      educativa. Maestra en Estudios Psicoanalíticos Freudianos y licenciada en
      psicología. Ponente en diversos congresos internacionales, así como la
      publicación de diversos artículos referentes a la inclusión y a la
      educación. Experiencia como consultora en ambientes empresariales,
      educativos y de asociaciones civiles.
    </p>
  </section>
);

const styles = {
  section: {
    padding: "20px",
    fontFamily: "Outfit, serif",
    fontWeight: "250",
  },
  heading: {
    fontFamily: "Outfit, sans-serif",
    color: "#AC4896",
    fontSize: "3rem",
    marginBottom: "-10px",
    textAlign: "right",
  },
  subheading: {
    textAlign: "right",
    fontSize: "1.75rem",
    fontWeight: "300",
    color: "#16C4C0",
    marginTop: "-10px",
    marginBottom: "90px",
  },
  text: {
    fontSize: "2rem",
    lineHeight: "1.6",
    textAlign: "justify",
  },
};

export default About;
